"use strict";

module.exports = function (accumulator, order, product, component) {
  return accumulator + "-".concat(component.length === 's' ? 'Short' : 'Long');
};